import { render, staticRenderFns } from "./ConfigMainTitle.vue?vue&type=template&id=3f1aacb6&"
import script from "./ConfigMainTitle.vue?vue&type=script&lang=js&"
export * from "./ConfigMainTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports